/**
 * Splits a formula expression into its tokens. Expressions are built by the
 * configure-formula dialog as whitespace-separated tokens — `$<id>` column
 * references, operators, parentheses and numeric constants — so a whitespace
 * split is the exact inverse of how they are written.
 */
export function getFormulaExpressionTokens(expression?: string): string[] {
  const trimmed = expression?.trim();

  return trimmed ? trimmed.split(/\s+/) : [];
}

/**
 * The tokens of a formula expression with each `$<id>` column reference
 * replaced by the column's name. A reference to a column missing from `columns`
 * keeps its `$`, so it never reads as a numeric constant.
 */
export function getFormulaDisplayParts(
  expression: string,
  columns: { id: number | string; name: string }[]
): string[] {
  const columnNames = new Map(
    (columns ?? []).map((column) => [String(column.id), column.name])
  );

  return getFormulaExpressionTokens(expression).map((token) =>
    token.startsWith('$') ? columnNames.get(token.slice(1)) ?? token : token
  );
}

/** A formula expression as readable text, or `undefined` when it is empty. */
export function getFormulaDisplayExpression(
  expression: string,
  columns: { id: number | string; name: string }[]
): string | undefined {
  return getFormulaDisplayParts(expression, columns).join(' ') || undefined;
}
